import { Component, OnInit } from '@angular/core';
import { BtnClickEvent, ButtonComponent } from '../shared/button/button.component';
import { IconTypes } from '../shared/icon/icon.component';
import { NgIf } from '@angular/common';
import { HubstaffMeDTO } from '../core/models/hubstaff-me.model';
import { HubstaffAccountComponent } from '../hubstaff-account/hubstaff-account.component';
import { ApiService } from '../core/services/api.service';
import { FlagService } from '../core/services/flag.service';
import { SpinnerComponent } from '../shared/spinner/spinner.component';
import { HubstaffApiService } from '../core/services/hubstaff-api.service';
import { WindowRefService } from '../core/services/windowRef.service';
import { MessageComponent } from '../shared/message/message.component';
import { IssueDetailsComponent } from '../issue-details/issue-details.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [NgIf, ButtonComponent, HubstaffAccountComponent, SpinnerComponent, MessageComponent, IssueDetailsComponent],
})
export class HomeComponent implements OnInit {
  me?: HubstaffMeDTO;
  showHubstaffAccount = false;
  showUserActivities = false;
  isSyncMe = false;
  issueKey = '';
  authUrl = '';
  loaded = false;

  constructor(
    private apiService: ApiService,
    private flagService: FlagService,
    private hubstaffApiService: HubstaffApiService,
    private windowRefService: WindowRefService,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit(): Promise<void> {
    this.issueKey = this.route.snapshot.paramMap.get('issueKey') || '';
    await this.loadMe();
    this.generateUrl();
    this.loaded = true;
  }

  get IconTypes() {
    return IconTypes;
  }

  loadUserActivities(): void {
    this.hideManageAccount();
    this.showUserActivities = true;
  }

  hideUserActivities(): void {
    this.showUserActivities = false;
  }

  handleAuthCheck(): void {
    this.isSyncMe = true;
    let count = 0;
    const id = setInterval(async () => {
      if (count > 20 || (this.me && this.me.id !== 'no-id')) {
        this.isSyncMe = false;
        clearInterval(id);
      }

      await this.loadMe();
      count++;
    }, 2000);
  }

  reload(): void {
    this.windowRefService.reload();
  }

  showManaageAccount(): void {
    this.showUserActivities = false;
    this.showHubstaffAccount = true;
    console.log('-ffff', this.showHubstaffAccount);
  }

  hideManageAccount(): void {
    this.showHubstaffAccount = false;
  }

  async removeToken(event: BtnClickEvent): Promise<void> {
    try {
      event.startSpinner();
      await this.hubstaffApiService.deleteMe();
      this.flagService.successMsg('Token was removed successfully');
      event.stopSpinner();
      this.hideManageAccount();
      this.me = undefined;
    } catch (errorResponse) {
      event.stopSpinner();
      console.error('Cannot remove token due to:', errorResponse);
      this.flagService.errorMsg('Cannot remove token. Try one more time or contact our support');
    }
  }

  private async loadMe(): Promise<void> {
    try {
      this.me = await this.apiService.get<HubstaffMeDTO>('/me');
    } catch (error) {
      console.error('Cannot get me info in home due to: ', error);
    }
  }

  private async generateUrl(): Promise<void> {
    const token = await this.windowRefService.AP.context.getToken();
    this.authUrl = `${this.windowRefService.LOCAL_URL}/auth/hubstaff?jwt=${token}`;
  }
}
